import { render, staticRenderFns } from "./DefaultToolbar.vue?vue&type=template&id=c8c86044&scoped=true"
import script from "./DefaultToolbar.vue?vue&type=script&lang=ts"
export * from "./DefaultToolbar.vue?vue&type=script&lang=ts"
import style0 from "./DefaultToolbar.vue?vue&type=style&index=0&id=c8c86044&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c86044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8c86044')) {
      api.createRecord('c8c86044', component.options)
    } else {
      api.reload('c8c86044', component.options)
    }
    module.hot.accept("./DefaultToolbar.vue?vue&type=template&id=c8c86044&scoped=true", function () {
      api.rerender('c8c86044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DefaultToolbar.vue"
export default component.exports